import React from 'react';
import type { CFCommitteeSummary } from '../../types/campaignFinance';
import { fmtMoney } from '../../utils/campaignFinanceUtils';
import StatCard, { StatCardRow } from '../StatCard';

interface CFKpiStripProps {
  summary: CFCommitteeSummary;
}

/**
 * Five-KPI strip for a committee: Raised · Spent · Cash on hand ·
 * Outstanding loans · Burn rate. Standard StatCards — variants carry the
 * semantic coloring (raised = success, spent = danger, cash = info,
 * loans = warning).
 */
const CFKpiStrip: React.FC<CFKpiStripProps> = ({ summary }) => {
  const burnPct = summary.burn_rate != null ? Math.round(summary.burn_rate * 100) : null;

  return (
    <StatCardRow minTileWidth="11rem">
      <StatCard label="Raised" value={fmtMoney(summary.total_raised, { compact: true })} variant="success" />
      <StatCard label="Spent" value={fmtMoney(summary.total_spent, { compact: true })} variant="danger" />
      <StatCard label="Cash on hand" value={fmtMoney(summary.cash_on_hand, { compact: true })} variant="info" />
      <StatCard label="Outstanding loans" value={fmtMoney(summary.outstanding_loan_balance, { compact: true })} variant="warning" />
      <StatCard
        label="Burn rate"
        value={burnPct != null ? `${burnPct}%` : '—'}
        sublabel={burnPct != null ? 'of funds raised spent' : undefined}
      />
    </StatCardRow>
  );
};

export default CFKpiStrip;
